import Vue from 'vue'

const state = Vue.observable({
  isMobile: window.matchMedia('(max-width: 768px)').matches
})

function updateDeviceType () {
  const userAgent = navigator.userAgent || window.opera
  const isMobile =
    /android|iPad|iPhone|iPod/.test(userAgent) ||
    window.matchMedia('(max-width: 768px)').matches
  state.isMobile = isMobile
}

export default {
  install (Vue) {
    updateDeviceType()

    // Listen for resize events to update device type
    window.addEventListener('resize', updateDeviceType)

    // Make state available on Vue prototype
    Vue.prototype.$deviceState = state
    // Vue.prototype.$deviceState = false
  }
}
